import { render, staticRenderFns } from "./OptionSelectorButton.vue?vue&type=template&id=2b6d318e&"
import script from "./OptionSelectorButton.vue?vue&type=script&lang=js&"
export * from "./OptionSelectorButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports